module.exports = __webpack_public_path__ + "static/media/b2.70fb8a13.jpg";